import React from 'react'
import { VscFilePdf, VscFileZip, VscFile } from 'react-icons/vsc'

const BYTE = 1000
const getKB = (bytes) => Math.round(bytes / BYTE)

const FileIcon = ({children}) => {
	return <span className="text-4xl">{children}</span>
}

const FileItem = props => {


	const { file, children } = props
	const { type, name, size,url } = file

	const renderThumbnail = () => {
		const isImageFile = type.split('/')[0] === 'image'

		if(isImageFile) {
			return <img 
				className="upload-file-image" 
				src={URL.createObjectURL(file)} 
				alt={`file preview ${name}`}
			/>
		}

		if(type === 'application/zip') {
			return <FileIcon><VscFileZip /></FileIcon>
		}

		if(type === 'application/pdf') {
			return <FileIcon><VscFilePdf /></FileIcon>
		}

		return <FileIcon><VscFile /></FileIcon>
	}

	return (
		<div className="upload-file">
			<div className="flex">
				
				<div className="upload-file-info">
				<a href={url} target="_blank"><h6 style={{fontSize:13}} className="upload-file-name">{name}</h6>
					<span style={{fontSize:12}} className="upload-file-size">{getKB(size)} kb</span></a>
				</div>
			</div>
			{children}
		</div>
	)
}

export default FileItem
